export const LOAD_MAKES_SUCCESS = 'LOAD_MAKES_SUCCESS';
export const LOAD_MODELS_SUCCESS = 'LOAD_MODELS_SUCCESS';

export const SET_FILTER = 'SET_FILTER';
export const FILTER_BODY_STYLES = 'FILTER_BODY_STYLES';
export const FILTER_MAKE = 'FILTER_MAKE';
export const FILTER_MODEL = 'FILTER_MODEL';
